import { Pipe, PipeTransform } from '@angular/core'

import { Survey } from "app/shared/model/index";
import { FollowupOnsiteGuestFilter } from 'app/states/followup-onsite/followup-onsite.state';

@Pipe({
    name: 'followupOnsiteCasesSurveyFilter',
    standalone: false
})
export class FollowupOnsiteCasesFilterPipe implements PipeTransform {

  transform(value: Survey[], filters: FollowupOnsiteGuestFilter): Survey[] {
    if(filters.cases) {

      if(!filters.cases.created && !filters.cases.non_created) return value;
      const filtered = value.filter(survey =>
        (survey.cases.length > 0 && filters.cases.created) ||
        (survey.cases.length === 0 && filters.cases.non_created)
      );
      return filtered;
    } else {
      return value;
    }
  }
}
